__turbopack_context__.v({
  "scroll-area": "SelectInput-module-scss-module__RB7K5G__scroll-area",
  "scroll-area__scrollbar": "SelectInput-module-scss-module__RB7K5G__scroll-area__scrollbar",
  "scroll-area__scrollbar__thumb": "SelectInput-module-scss-module__RB7K5G__scroll-area__scrollbar__thumb",
  "scroll-area__viewport": "SelectInput-module-scss-module__RB7K5G__scroll-area__viewport",
  "select-content": "SelectInput-module-scss-module__RB7K5G__select-content",
  "select-content__item": "SelectInput-module-scss-module__RB7K5G__select-content__item",
  "select-trigger": "SelectInput-module-scss-module__RB7K5G__select-trigger",
  "select-trigger__icon": "SelectInput-module-scss-module__RB7K5G__select-trigger__icon",
  "select-trigger__value": "SelectInput-module-scss-module__RB7K5G__select-trigger__value",
});
